import { CurrencyCode } from './currency';

export interface Partner {
  id: string;
  alias: string;
  name: string;
  paymentMethods: string[] | null;
}

export interface Price {
  value: number;
  currency: CurrencyCode;
  valueFormer?: number;
  salePercentage?: number;
}

export interface Shipping {
  price?: number;
  currency: CurrencyCode;
  originalDeliveryTime?: string | null;
  info?: string;
}

export type EnergyEfficiencyGrade = 'A' | 'B' | 'C' | 'D' | 'E' | 'F' | 'G';

export interface Features {
  width: string[];
  colour: string[];
  typeOfFireplace: string[];
  price: number;
  sale: boolean;
  shop: string;
  style: string[];
  paymentMethod?: string[];
  deliveryTime: string[];
  materialLamps: string[];
  material: string[];
  extrasLamps: string[];
  energyEfficiency: string[];
  brand: string[];
  designTextiles: string[];
  usageProtectiveCoversSeatCovers: string[];
  services: string[];
  materialCutleryDishes: string[];
  [key: string]: any;
}

export interface Display {
  desktop: boolean;
  mobile: boolean;
}

export interface Rating {
  score?: number;
  count?: number;
}

export interface CreatedAt {
  value: Date;
  matchLevel: string;
}

export interface Voucher {
  valuePercentage?: number;
  valueAmount?: number;
  text?: string;
  code?: string;
}

export interface Product {
  createdAt: string;
  productId: string;
  title: string;
  clickoutUrl: string;
  partner: Partner;
  images: string[];
  price: Price;
  locations?: string[] | null;
  shipping: Shipping;
  features?: Features | null;
  category: string;
  display: Display;
  rating?: Rating;
  objectID: string;
  voucher?: Voucher;
  flags: ProductFlags[];
  categoryNames: string[];

  // A wishlist product, that is not in index anymore.
  isOffline?: boolean;

  // Is a DY recommended product
  isDYRecommended?: boolean;
}

export interface FeatureHighlight {
  name: string;
  value: string;
}

export interface WishListItem extends Omit<Product, 'features'> {}

export enum ProductFlags {
  promotion = 'promotion',
  topseller = 'topSeller',
  favorite = 'favorite',
  recommended = 'recommended',
}

export interface PriceBase {
  currency: string;
  unit: string;
  value: number;
}
export interface Title {
  value: string;
  matchLevel: string;
  matchedWords: any[];
}

export interface HighlightResult {
  title: Title;
}

export interface RankingInfo {
  nbTypos: number;
  firstMatchedWord: number;
  proximityDistance: number;
  userScore: number;
  geoDistance: number;
  geoPrecision: number;
  nbExactWords: number;
  words: number;
  filters: number;
}

export interface ProductRatingProps {
  score?: number;
  count?: number;
}

export interface HitsItem {
  createdAt: string;
  productId: string;
  category: string;
  display: Display;
  locations: any[];
  clickoutUrl?: string;
  partner: Partner;
  images: string[];
  title: string;
  price: Price;
  priceBase?: PriceBase;
  shipping?: Shipping;
  objectID: string;
  features?: Features | null;
  modifiedAt?: string;
  partnerProductKey?: string;
  singleItem?: boolean;
  handMade?: boolean;
  _highlightResult?: HighlightResult;
  _rankingInfo?: RankingInfo;
  voucher?: Voucher;
  flags?: ProductFlags[];
  rating?: ProductRatingProps;
}
